import React, { Fragment, useEffect, useState } from 'react';
import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';

import { Container, Row, Col } from 'reactstrap';
import { ContentAbout0, ContentAbout1, ContentAbout2, ContentAbout3, ContentAbout4, ContentRegister0, ContentRegister1, ContentRegister2, ContentRegister3 } from './_ContentBlocks';
import { TextBock, TextHeader, TextTitle } from '../../../Controls/Digital/TextHeaders';
import AnimatedImage from '../../../Controls/Digital/AnimatedImage';

import img_1 from '../Resources/Images/catering-1.jpg';
import img_2 from '../Resources/Images/catering-2.jpg';
import img_3 from '../Resources/Images/catering-3.jpg';
import img_4 from '../Resources/Images/catering-4.jpg';

const Catering = (props) =>{

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    return (
        <Block name="catering" isAlt={true}>

            <TextHeader text={
                <Fragment>
                    Catering & Events
                </Fragment>
            } />

            <TextTitle text={
                <Fragment>
                    Let us prepare your party !!!
                </Fragment>
            }/>

            <TextBock text={
                <Fragment>
                    We have plenty of experience organising differnet types of caterings; from office lunches to birthday's parties
                </Fragment>
            } />

            <Row>
                {/*<Col lg={{ size:10, offset : 1 }}>*/}
                {/*    <Container>*/}
                {/*        <Row>*/}
                {/*            <Col>*/}
                {/*                <img src={img_1} className="img-fluid catering-photo"/>*/}
                {/*            </Col>*/}
                {/*            <Col>*/}
                {/*                <img src={img_2} className="img-fluid catering-photo" />*/}
                {/*            </Col>*/}
                {/*        </Row>*/}
                {/*        <Row>*/}
                {/*            <Col>*/}
                {/*                <img src={img_3} className="img-fluid catering-photo" />*/}
                {/*            </Col>*/}
                {/*            <Col className="catering-text">*/}
                {/*                <TextBock text={*/}
                {/*                    <Fragment>*/}
                {/*                            <br />*/}
                {/*                        In parnership with <span className="catering-highlight">La Signoria Cafe</span> we can acommodate most of*/}
                {/*                    </Fragment>*/}
                {/*                } />*/}
                {/*            </Col>*/}
                {/*        </Row>*/}
                {/*    </Container>*/}
                {/*</Col>*/}

                <Col lg={{ size: 5, offset: 1 }}>
                    <img src={img_1} className="img-fluid catering-photo"/>
                </Col>
                <Col lg="5">
                    <img src={img_2} className="img-fluid catering-photo" />
                </Col>
                <Col lg={{ size: 5, offset: 1 }}>
                    <img src={img_3} className="img-fluid catering-photo" />
                </Col>

                <Col lg="5" className="img-text-container">

                    <TextBock addClass="left-text img-text-bottom" text={
                        <Fragment>
                            We work in parnership with <span className="catering-highlight">La Signoria Cafe</span> in Port Kembla<br />
                            With them; we can acommodate any type of event (breakfast, brunchs, formal dinners, and any type of party)<br/>
                            From formal glazing tables to sweet tooth; Challenge us!!!!<br/>
                        </Fragment>
                    } />

                    <TextBock addClass="left-text" text={
                        <Fragment>
                            Just reach out using our contact details below
                        </Fragment>
                    } />
                </Col>
            </Row>

        </Block>
    );
}
export default Catering;
